import { useCallback, useState } from 'react';
import { Pagination as BasePagination } from '@carbon/react';

import styles from 'theme/components/cursor-pagination.module.scss';

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

export const usePagination = () => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const handleResetPage = useCallback(() => setPage(DEFAULT_PAGE), []);

  const handleReset = useCallback(() => {
    handleResetPage();
    setPageSize(DEFAULT_PAGE_SIZE);
  }, [handleResetPage]);

  const handleChangePageSize = useCallback(
    (pageSize) => {
      handleReset();
      setPageSize(pageSize);
    },
    [handleReset]
  );

  return {
    page,
    pageSize,
    setPageSize: handleChangePageSize,
    setPage,
    reset: handleReset,
    resetPage: handleResetPage
  };
};

const Pagination = ({ page, pageSize, onPageChange, onPageSizeChange, isLastPage }) => (
  <BasePagination
    className={styles.wrapper}
    page={page}
    pageRangeText={() => `Page ${page}`}
    pageSize={pageSize}
    pageSizes={[5, 10, 20]}
    onChange={({ page: newPage, pageSize: newPageSize }) => {
      if (page !== newPage) {
        onPageChange(newPage);
      }

      if (pageSize !== newPageSize) {
        onPageSizeChange(newPageSize);
      }
    }}
    size="sm"
    isLastPage={isLastPage}
  />
);

export default Pagination;
